/**
 * @copyright 2019 @ DigiNet
 * @author THANHTRAM
 * @create 2019/08/12 11:00
 * @update 2019/08/12 11:00
 */

import React from 'react';
import { InputGroup } from 'react-bootstrap';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as w19F1030Actions from "../../actions/w19/w19f1030/w19f1030-actions";
import * as userActions from "../../actions/user-actions";

import EventTracking from "../common/tracking/event";
import Config from "../../config";
import {Column} from "devextreme-react/data-grid";
import notify from "devextreme/ui/notify";
import {DateBox, Validator} from "devextreme-react";
import InputGroupAddon from "react-bootstrap/es/InputGroupAddon";
import Combo from "../common/dropdown/combo";
import {CompareRule} from "devextreme-react/validator";
import {browserHistory} from "react-router";

import moment from "moment";
import 'moment/locale/vi'
import DropDownTypeTime from "../common/dropdown/template/dropdown-type-time";
import * as w19F1031Action from "../../actions/w19/w19F1031/w19f1031-actions";
import DropDownSalePerson from "../common/dropdown/template/dropdown-sale-person";
import DOMPurify from "dompurify";
import ButtonExport from "../common/button/button-export";
import DropDownSaleGroup from "../common/dropdown/dropdown-sale-group";

// Preview files
import FileViewer from "../common/fileviewer/fileviewer";
import Slider from "react-slick";
import { Row, Col, Button as ButtonCore, Typography, ButtonIcon, Collapse, Image, Chip, Modal, ModalHeader, ModalBody } from 'diginet-core-ui/components';
import Icons from "diginet-core-ui/icons";
import { makeStyles } from "diginet-core-ui/theme";

const Button = (props) => <ButtonCore size={"small"} labelProps={{ style: { color: 'initial' } }} {...props} />;

moment.locale('vi');

const styles = {
    slick: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        position: 'absolute',
        top: "50%",
        zIndex: 2,
    }
};

const useStyles = makeStyles((theme) => ({
    boardInfo: {
        position: 'relative',
        border: `1px solid ${theme.colors.fill.background}`
    },
    image: {
        minWidth: 80,
        '& > img': {
            objectFit: 'initial'
        }
    },
    btnAction: {
        display: 'grid',
    },
    borderRight: {
        borderRight: `1px solid ${theme.colors.fill.background}`,
        minHeight: 100
    },
    titleBoard: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        color: 'black',
        paddingLeft: '20%'
    },
    chipIcon: {
        '& > img': {
            objectFit: 'contain'
        }
    },
    chip: {
        maxWidth: 200,
    },
    chipDiv: {
        '& > *': {
            marginBottom: 0
        }
    }
}));

const NextArrow = props => {
    const { onClick } = props;
    return (
        <ButtonIcon
            circular
            size={"medium"}
            viewType={"text"}
            name={"ArrowRight"}
            style={{ ...styles.slick, left: "93.5%" }}
            onClick={onClick} />
    );
}

const PrevArrow = props => {
    const { onClick } = props;
    return (
        <ButtonIcon
            circular
            size={"medium"}
            viewType={"text"}
            name={"ArrowLeft"}
            style={{ ...styles.slick, left: "2%" }}
            onClick={onClick} />
    );
}

class W19F1030Page extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            iPermission: 0,
            collapse: false,
            search: '',
            salePersonID: '',
            transTypeID: '',
            evaluateTypeID: '',
            typeTime: '',
            CreateDateFrom: '',
            CreateDateTo: '',
            groupSalesID: '',
            currentSlide: 0,
            attachmentStatus: []
        };
        this.filter = {
            skip: 0,
            limit: 10,
            search: '',
        };
        this.isReload = !!props.location.state;
        this.dataEvaluation = [];
        this.dataSalePerson = [];
        this.typeTimeID = '';
        this.mode = '';
        this.timer = null;
        this.timeDeplay = 3000;
    };

    toggle() {
        this.setState({collapse: !this.state.collapse});
    }

    componentDidMount = async () => {
        await this.loadPermission();
        if (this.state.iPermission <= 0) return;
        this.loadEvaluation();
        this.loadFilters();
    };

    async loadPermission() {
        await this.props.userActions.getPermission(Config.profile.UserID, "D17F1930", (iPer) => {
            this.setState({iPermission: iPer});
        });
    }

    formatDate = (date) => {
        if (date) {
            return moment(date).format('MM/DD/YYYY');
        } else {
            return '';
        }
    };

    loadFilters() {
        const filters = Config.getStoreState(this);
        if (filters) {
            this.filter.search = filters.search;
            this.loadGrid();
        }
    }

    loadGrid() {
        const paramGrid = {
            "SalesPersonID": this.state.salePersonID,
            "EvaluateTypeID": this.state.evaluateTypeID,
            "DateFrom": this.formatDate(this.state.CreateDateFrom),
            "DateTo": this.formatDate(this.state.CreateDateTo),
            "StrSearch": this.filter.search,
            "GroupSalesID": this.state.groupSalesID
        };
        this.props.w19F1030Actions.loadGrid(paramGrid, (error, data) => {
            if (error) {
                let errorCode = error.code || null;
                let message = "";
                if (errorCode === "F1022E002") {
                    message = Config.lang("Ban_chua_chon_ngay_den");
                    Config.popup.show('INFO', message);
                } else {
                    message = error.message || Config.lang("Loi_chua_xac_dinh");
                    Config.popup.show('INFO', message);
                }
                this.setState({isSubmit: false, message: message, loading: false});
                return false;
            }
            if (data?.rows.length > 0) {
                let dataAttStatus = [];
                for (let i = 0; i < data.rows.length; i++) {
                    dataAttStatus.push({ evaluateID: data.rows[i].EvaluateID, status: false });
                }
                this.setState({ attachmentStatus: dataAttStatus });
            }
        });
    }

    loadEvaluation() {
        this.props.w19F1030Actions.loadCbEvaluation({}, (error, data) => {
            if (error) {
                let errorCode = error.code || null;
                let message = "";
                if (errorCode === "F1022E002") {
                    message = Config.lang("Ban_chua_chon_ngay_den");
                    Config.popup.show('INFO', message);
                } else {
                    message = error.message || Config.lang("Loi_chua_xac_dinh");
                    Config.popup.show('INFO', message);
                }
                this.setState({isSubmit: false, message: message, loading: false});
            } else if (data && data.length > 0) {
                this.dataEvaluation = data.map(o => {
                    return {
                        EvaluateTypeID: o.EvaluateTypeID,
                        EvaluateTypeName: o.EvaluateTypeName
                    };
                });
            } else {
                this.dataEvaluation = [];
            }
        });
    }

    onChangeComboSalePerson(data) {
        if (data) {
            this.setState({
                salePersonID: data.SalesPersonID
            }, () => {
                this.loadGrid()
            });
        } else {
            this.setState({
                salePersonID: ''
            }, () => {
                this.loadGrid()
            });
        }
    }

    onChangeComboEvaluation(data) {
        if (data) {
            this.setState({
                evaluateTypeID: data.EvaluateTypeID
            }, () => {
                this.loadGrid()
            });
        } else {
            this.setState({
                evaluateTypeID: ''
            }, () => {
                this.loadGrid()
            });
        }
    }

    onChangeTimeEnd(data, mode) {
        if (!this.isReload || !mode) {
            this.setState({
                CreateDateTo: data.DateTo,
                CreateDateFrom: data.DateFrom,
                typeTime: data.ID
            }, () => {
                this.loadGrid()
            });
        }
    }

    onSearch(text) {
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.setState({
            search: text
        },()=>{
            this.timer = setTimeout(() => {
                this.filter.search = text;
                this.loadGrid()
            }, 500);
        });

    }

    onAddNew() {
        browserHistory.push({
            pathname: Config.getRootPath() + 'W19F1031',
            state: {mode: "add"}
        });
    }

    onEdit(value) {
        const evaluateID = value && value.EvaluateID ? value.EvaluateID : '';
        const storeData = {
            collapse: this.state.collapse,
            search: this.filter.search,
            salePersonID: this.state.salePersonID,
            evaluateTypeID: this.state.evaluateTypeID,
            typeTime: this.state.typeTime,
            CreateDateFrom: this.state.CreateDateFrom,
            CreateDateTo: this.state.CreateDateTo
        };
        Config.setStoreState(this, storeData);
        browserHistory.push({
            pathname: Config.getRootPath() + 'W19F1031',
            state: {mode: "edit", id: evaluateID}
        });
    }

    onDelete(value) {
        const evaluateID = value && value.EvaluateID ? value.EvaluateID : '';
        Config.popup.show("YES_NO", `${Config.lang("Ban_co_chac_chan_muon_xoa_du_lieu_nay")}`, () => {
            const param = {
                "EvaluateID": evaluateID
            };
            this.props.w19F1030Actions.deleteEvaluation(param, async (error) => {
                if (error) {
                    let errorCode = error.code || null;
                    let message = "";
                    switch (errorCode) {
                        case "F1030E001":
                            message = Config.lang("Xoa_");
                            Config.popup.show('INFO', message);
                            break;
                        case "F1030E002":
                            message = Config.lang("Khu_vuc_nay_da_co_nhan_vien_so_huu");
                            Config.popup.show('INFO', message);
                            break;
                        case "F1030E003":
                            message = Config.lang("Khu_vuc_nay_da_co_nhan_vien_so_huu");
                            Config.popup.show('INFO', message);
                            break;
                        default:
                            message = error.message || Config.lang("Loi_chua_xac_dinh");
                            Config.popup.show('INFO', message);
                            break;
                    }
                    this.setState({isSubmit: false, message: message, loading: false});
                    return false;

                } else {
                    const historyStatus = await this.saveHistory(evaluateID);
                    if (historyStatus !== 200) {
                        Config.popup.show("INFO", Config.lang('Co_loi_khi_luu'));
                        return false;
                    }
                    notify(Config.lang("Du_lieu_da_xoa_thanh_cong"), "success", 2000);
                    this.loadGrid();
                }
            });
        });
    }


    saveHistory = async (evaluateID) => {
        let el = {};
        let data = [];
        let status = '';
        el.codeID = evaluateID;
        el.formID = 'W19F1030';
        el.linkedTrans = '';
        el.oldValue = evaluateID;
        el.newValue = '';
        el.description84 = Config.lang("Danh_sach_danh_gia_chung", 'vi');
        el.description01 = Config.lang("Danh_sach_danh_gia_chung", 'en');
        el.action = 2;
        data.push(el);
        const param = {
            attributes: JSON.stringify(data)
        };
        await this.props.w19F1031Action.addHistory(param, (error) => {
            status = error ? 400 : 200
        });
        return status
    };

    onChangeGroupSales = (e) => {
        this.setState({
            groupSalesID:e
        },()=>{
            this.loadGrid();
        })
    };

    renderIconName = (file, url) => {
        const classes = useStyles();
        let ext = file ? file.split('.') : '';
        ext = ext[ext.length - 1];
        let iconSrc = url;
        switch (ext) {
            case 'doc':
                iconSrc = "../../images/file/icon-doc.png";
                break;
            case 'docx':
                iconSrc = "../../images/file/con-docx.png";
                break;

            case 'xls':
                iconSrc = "../../images/file/icon-xls.png";
                break;
            case 'xlsx':
                iconSrc = "../../images/file/icon-xlsx.png";
                break;

            case 'ppt':
                iconSrc = "../../images/file/icon-ppt.png";
                break;
            case 'pptx':
                iconSrc = "../../images/file/icon-pptx.png";
                break;

            case 'pdf':
                iconSrc = "../../images/file/icon-pdf.png";
                break;

            case 'txt':
                iconSrc = "../../images/file/icon-txt.png";
                break;

            default:
                break;
        }
        return <Image width={'100%'} height={'100%'} className={classes.chipIcon} alt="" src={iconSrc} />
    };

    render() {
        if (this.state.iPermission <= 0) return null;
        const classes = useStyles();
        const {dataGrid} = this.props;
        const {showFileViewer, attachmentStatus} = this.state;

        const paramPrint = [
            {type: "Varchar", id: "UserID", value: Config.profile.UserID},
            {type: "Varchar", id: "Language", value: Config.language || '84'},
            {type: "NVarChar", id: "StrSearch", value: this.filter.search},
            {type: "NVarChar", id: "SalesPersonID", value: this.state.salePersonID},
            {type: "VarChar", id: "EvaluateTypeID", value: this.state.evaluateTypeID},
            {type: "DATETIME", id: "DateFrom", value: this.formatDate(this.state.CreateDateFrom)},
            {type: "DATETIME", id: "DateTo", value: this.formatDate(this.state.CreateDateTo)},
            {type: "VarChar", id: "GroupSalesID", value: this.state.groupSalesID},
        ];
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            lazyLoad: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
			afterChange: index => this.setState({currentSlide: index})
        };
        return (
            <div className="page-container" id="W19F1030" style={{minHeight: '400px'}}>
                <EventTracking category={"TRACKING_USER"} action={"W18F1022"} label={Config.profile.UserID}/>
                <Row>
                    <Col xs={12}>
                        <Typography type={"h4"} color={"info"}>{Config.lang('Danh_sach_danh_gia_chung')}</Typography>
                    </Col>
                    <Col xs={12} sm={2} verticalAlign={'center'}>
                        <Button
                            color={'info'}
                            startIcon={"Add"}
                            disabled={this.state.iPermission < 2}
                            label={Config.lang('Them_moi1')}
                            onClick={() => {
                                if (this.state.iPermission >= 2) {
                                    this.onAddNew()
                                }
                            }}
                        />
                    </Col>
                    <Col xs={12} sm={7}>
                        <InputGroup className={'height100'} style={{ width: '100%' }}>
                            <input id={'search-user-profile'} autoComplete={'off'}
                                placeholder={Config.lang("Nhap_noi_dung_kien_nghi_can_tim_kiem")}
                                onChange={(e) => this.onSearch(e.target.value)} type="text"
                                value={this.state.search}
                                className="form-control height100" />
                            <InputGroupAddon id={'search-button-user-profile'} className={'cursor-pointer'}>
                                <Icons
                                    name={!this.state.collapse ? "ArrowDown" : "ArrowUp"}
                                    onClick={() => {
                                        this.toggle();
                                    }}
                                />
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                    <Col xs={12} sm={3} verticalAlign={'center'}>
                        <ButtonExport name={Config.lang('Xuat_du_lieu')}
                            transTypeID={'ExportQuotation'}
                            reportTypeID={'W19F1030'}
                            param={paramPrint} />
                    </Col>
                    <Col xs={12}>
                        <Row>
                            <Col xs={0} sm={0} md={2} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} />
                            <Col xs={12} sm={12} md={7}>
                                <Collapse open={this.state.collapse}>
                                    <Row>
                                        <Col xs={12} sm={6} md={4}>
                                            <DropDownSaleGroup showClearButton={true}
                                                onChange={this.onChangeGroupSales}
                                                placeholder={Config.lang('Nhom_kinh_doanh')}
                                                value={this.state.groupSalesID}
                                            />
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <DropDownSalePerson showClearButton={true}
                                                groupSalesID={this.state.groupSalesID}
                                                placeholder={Config.lang("Nhan_vien_kinh_doanh")}
                                                value={this.state.salePersonID}
                                                reset={this.state.resetComboPS}
                                                onChange={(e) => {
                                                    this.onChangeComboSalePerson(e)
                                                }} />
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <Combo
                                                dataSource={this.dataEvaluation}
                                                showClearButton={true}
                                                placeholder={Config.lang("Loai_danh_gia")}
                                                valueExpr={'EvaluateTypeID'}
                                                displayExpr={'EvaluateTypeName'}
                                                value={this.state.evaluateTypeID}
                                                onActionWhenSelectChange={(value) => {
                                                    this.onChangeComboEvaluation(value)
                                                }}
                                            >
                                                <Column dataField={'EvaluateTypeID'} caption={Config.lang("Ma")}
                                                    visible={false}
                                                    dataType={'string'} />
                                                <Column dataField={'EvaluateTypeName'}
                                                    caption={Config.lang("Ten")}
                                                    dataType={'string'} />
                                            </Combo>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <DropDownTypeTime
                                                listType={"W19F1030_TypeTime"}
                                                placeholder={""}
                                                value={this.state.typeTime}
                                                onChange={(data) => this.onChangeTimeEnd(data)}
                                                onLoad={(data) => this.onChangeTimeEnd(data, 'load')}
                                            >
                                            </DropDownTypeTime>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <DateBox
                                                width={"100%"}
                                                id={'CreateDateFrom'}
                                                openOnFieldClick={true}
                                                useMaskBehavior={true}
                                                showClearButton={true}
                                                value={this.state.CreateDateFrom}
                                                type={'date'}
                                                pickerType={"calendar"}
                                                showAnalogClock={false}
                                                displayFormat={'dd/MM/y'}
                                                onValueChanged={(e) => {
                                                    this.setState({
                                                        CreateDateFrom: e.value
                                                    }, () => {
                                                        this.loadGrid()
                                                    })
                                                }}
                                            >
                                            </DateBox>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <DateBox
                                                width={"100%"}
                                                id={'CreateDateTo'}
                                                openOnFieldClick={true}
                                                useMaskBehavior={true}
                                                showClearButton={true}
                                                value={this.state.CreateDateTo}
                                                type={'date'}
                                                pickerType={"calendar"}
                                                showAnalogClock={false}
                                                displayFormat={'dd/MM/y'}
                                                onValueChanged={(e) => {
                                                    this.setState({
                                                        CreateDateTo: e.value
                                                    }, () => {
                                                        this.loadGrid()
                                                    })
                                                }}
                                            >
                                                <Validator>
                                                    <CompareRule
                                                        message={Config.lang("Ngay_den_phai_lon_hon_ngay_tu")}
                                                        reevaluate={false}
                                                        ignoreEmptyValue={true}
                                                        comparisonType={'>='}
                                                        comparisonTarget={() => {
                                                            return this.state.CreateDateFrom
                                                        }}
                                                    />
                                                </Validator>
                                            </DateBox>
                                        </Col>
                                    </Row>
                                </Collapse>
                            </Col>
                            <Col xs={0} sm={0} md={3} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} />
                        </Row>
                    </Col>
                    <Col xs={12}>
                        <div className={classes.titleBoard}>
                            <Typography type={'title4'}>{Config.lang("Noi_dung")}</Typography>
                            <Typography type={'title4'}>{Config.lang("Kien_nghi")}</Typography>
                            <Typography type={'title4'}>{Config.lang("Ghi_chu")}</Typography>
                        </div>

                        {dataGrid && dataGrid.total === 0 && <div style={{
                            width: '100%', height: '100%', display: "flex", justifyContent: "center"
                        }}>
                            {Config.lang("Khong_co_du_lieu")}
                        </div>}
                    </Col>
                    {dataGrid && dataGrid.rows && dataGrid.rows.length > 0 && dataGrid.rows.map((value, index) => {
                        const statusChip = attachmentStatus.find(item => item.evaluateID === value.EvaluateID);
                        return (
                            <Col xs={12} key={index} className={classes.boardInfo}>
                                <Row>
                                    <Col xs={12} sm={4} md={2} className={classes.borderRight}>
                                        <div className={"display_row align-center"}>
                                            <Image className={classes.image} height={80} width={80} src={value?.URL} />
                                            <div className={'pbl2x'}>
                                                <Typography type={'h4'} color={'info'} className={'mgb1x'}>{value.SalesPersonNameU}</Typography>
                                                <Typography type={'p2'} color={'secondary'}>{moment(value.EvaluationDate).format("DD/MM/YYYY")}</Typography>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={8} md={4} className={classes.borderRight}>
                                        <div className={"height100 full_w"} style={{ position: 'relative' }}>
                                            <div className="evaluation_content"
                                                 style={{float: "left", whiteSpace: "pre-wrap"}}>
                                                <Typography type={'p1'} color={'secondary'}>{Config.lang("Noi_dung")}:</Typography>
                                                <div
                                                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(value.Content)}}
                                                    className='editor-content'/>
                                            </div>
                                            <div className={'ribbon'} style={{
                                                backgroundColor: value.Color,
                                            }}>
                                                {value.EvaluateTypeName}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={6} md={3} className={classes.borderRight}>
                                        <div style={{ float: "left", whiteSpace: "pre-wrap" }}>
                                            <Typography type={'p1'} color={'secondary'}>{Config.lang("Kien_nghi")}:</Typography>
                                            <div
                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value?.Recommendation) }}
                                                    className="editor-recommendation" />
                                        </div>
                                    </Col>

                                    <Col xs={12} sm={6} md={3} className={'display_row align-between'}>
                                        <div style={{ float: "left", whiteSpace: "pre-wrap" }}>
                                            <Typography type={'p1'} color={'secondary'}>{Config.lang("Ghi_chu")}:</Typography>
                                            <div
                                                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(value?.Notes)}}
                                                    className="editor-recommendation"/>
                                        </div>
                                        <div className={classes.btnAction}>
                                            <ButtonIcon
                                                circular
                                                disabled={this.state.iPermission < 3}
                                                name={"Edit"}
                                                size={"medium"}
                                                color={"warning"}
                                                viewType={"text"}
                                                onClick={() => {
                                                    if (this.state.iPermission >= 3) {
                                                        this.onEdit(value)
                                                    }
                                                }}/>
                                            <ButtonIcon
                                                circular
                                                disabled={this.state.iPermission < 4}
                                                name={"Delete"}
                                                size={"medium"}
                                                color={"danger"}
                                                viewType={"text"}
                                                onClick={() => {
                                                    if (this.state.iPermission >= 4) {
                                                        this.onDelete(value)
                                                    }
                                                }}/>
                                        </div>
                                    </Col>
                                    {value?.attached &&
                                        <>
                                            <Col xs={0} sm={0} md={2} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} />
                                            <Col xs={12} sm={12} md={10}>
                                                <div className={`${classes.chipDiv} wrap mgb2x align-center`} style={{ float: "left", width: '100%', position: 'relative' }}>
                                                    {value.attached.length ? value.attached.map((attachment, idx) => {
                                                        if (idx > 2 && !statusChip?.status) {
                                                            return null;
                                                        }
                                                        return (<Chip className={`${classes.chip} overflow-one-line mgr2x`} startIcon={this.renderIconName(attachment.FileName, attachment.URL)} onClick={() => { this.setState({ showFileViewer: value, slideIndex: index, currentSlide: index }) }}
                                                            key={idx}>{attachment.FileName}
                                                        </Chip>)
                                                    }) : ''}
                                                    {value.attached.length && value.attached.length > 3 && !statusChip?.status ?
                                                        <Chip onClick={() => {
                                                            const dataListStatus = [...attachmentStatus];
                                                            dataListStatus.find(item => item.evaluateID === value.EvaluateID).status = true;
                                                            this.setState({ attachmentStatus: dataListStatus });
                                                        }}>{`+${value.attached.length - 3}`}</Chip>
                                                        : ''
                                                    }
                                                </div>
                                            </Col>
                                        </>
                                    }
                                </Row>
                            </Col>
                        );
                    })}

                    {showFileViewer &&
                        <Modal
                            alignment={"center"}
                            size={"lg"}
                            open={!!showFileViewer}
                            onClose={() => { this.setState({ showFileViewer: null }) }}>
                            <ModalHeader>{Config.lang('Xem_tap_tin') + '#%#' + (showFileViewer.attached[this.state.currentSlide]?.FileName || "")}</ModalHeader>
                            <ModalBody>
                                <Slider initialSlide={this.state.slideIndex} {...settings}>
                                    {showFileViewer.attached.map((file, idx) => {
                                        const FileName = file && file.FileName ? file.FileName : "";
                                        const FileExt = file && file.fileExt ? file.fileExt : Config.helpers.getExtFile(file ? file.FileName : '');
                                        const URL = file && file.URL ? (file.URL.indexOf('http') < 0 ? Config.env.cdn + '/' + file.URL : file.URL) : "";
                                        return (
                                            <FileViewer
                                                key={idx}
                                                fileName={FileName}
                                                filePath={URL}
                                                fileType={FileExt}
                                                height={790} />
                                        )
                                    })}
                                </Slider>
                            </ModalBody>
                        </Modal>
                    }
                </Row>
            </div>
        )
    }
}

export default connect(state => ({
    dataGrid: state.w19f1030.dataGrid,
    cbSalePerson: state.w19f1030.cbSalePerson,
    cbEvaluation: state.w19f1030.cbEvaluation,
    deleteEvaluation: state.w19f1030.deleteEvaluation,
    cbTypeTime: state.w19f1030.cbTypeTime,
}),
    (dispatch) => ({
        w19F1030Actions: bindActionCreators(w19F1030Actions, dispatch),
        w19F1031Action: bindActionCreators(w19F1031Action, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
    })
)(W19F1030Page);
